import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
//eslint-disable-next-line
import { css } from "styled-components/macro";
import { SectionHeading } from "components/misc/Headings.js";
import defaultCardImage from "../../images/shield-icon.svg";
import { ReactComponent as SvgDecoratorBlob3 } from "../../images/svg-decorator-blob-3.svg";

import SupportIconImage from "../../images/support-icon.svg";
import ShieldIconImage from "../../images/shield-icon.svg";
import CustomizeIconImage from "../../images/customize-icon.svg";
import FastIconImage from "../../images/fast-icon.svg";
import ReliableIconImage from "../../images/reliable-icon.svg";
import SimpleIconImage from "../../images/simple-icon.svg";

const Container = tw.div`relative border-t-2 w-full `;

const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center max-w-screen-xl mx-auto py-20 md:py-24`}
`;

const Heading = styled(SectionHeading)`
  ${tw`w-full text-center text-xl lg:text-2xl xl:text-3xl`};
  font-family: "CustomFont", serif;
  color: var(--primary-color);
  text-align: center;
  direction: rtl;

  &.special {
    ${tw`text-3xl lg:text-4xl xl:text-5xl`};
  }
`;

const Column = styled.div`
  ${tw`md:w-1/2 lg:w-1/3 px-6 flex`}
`;

const Card = styled.div`
  ${tw`flex flex-col mx-auto max-w-xs items-center px-6 py-10 border-2 border-dashed rounded-lg mt-12`};
  border-color: var(--primary-color);
  font-family: "CustomFont", serif;
  transition: all 0.3s ease-in-out;
  background: white;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 40px rgba(199, 138, 65, 0.15);
    border-style: solid;
  }

  .imageContainer {
    ${tw`text-center rounded-full p-6 flex-shrink-0 relative`};
    border: 2px solid var(--primary-color);
    transition: all 0.3s ease-in-out;
    background: linear-gradient(
      135deg,
      rgba(199, 138, 65, 0.1) 0%,
      rgba(199, 138, 65, 0.05) 100%
    );

    img {
      ${tw`w-8 h-8`}
    }
  }

  &:hover .imageContainer {
    background: linear-gradient(
      135deg,
      rgba(199, 138, 65, 0.2) 0%,
      rgba(199, 138, 65, 0.1) 100%
    );
    transform: scale(1.1);
  }

  .textContainer {
    ${tw`mt-6`};
    text-align: center;
    direction: rtl;
  }

  .title {
    font-family: "CustomFont", serif;
    ${tw`mt-2 font-bold leading-snug text-xl lg:text-2xl xl:text-3xl`};
    color: var(--primary-color);
    text-align: center;
    direction: rtl;
  }

  .description {
    font-family: "CustomFont", serif;
    ${tw`mt-3 leading-relaxed text-base lg:text-lg xl:text-xl`};
    color: #333;
    font-weight: normal;
    text-align: center;
    direction: rtl;
  }
`;

const DecoratorBlob = styled(SvgDecoratorBlob3)`
  ${tw`pointer-events-none absolute right-0 bottom-0 w-64 opacity-25 transform translate-x-32 translate-y-48`}
`;

export default () => {
  const cards = [
    {
      imageSrc: ShieldIconImage,
      title: "اسلام کا پیغام عام کرنے کا عزم",
      description:
        "1. اللہ تعالیٰ کی بندگی اور اس کے دین کی سربلندی کے لیے اسلام کے پیغام کو تعلیم، تربیت اور دعوت کے ذریعے دنیا بھر میں عام کرنا۔",
    },
    {
      imageSrc: SupportIconImage,
      title: "اسلامی ورثے کا تحفظ اور فروغ",
      description:
        "2. اسلامی تعلیمات، ثقافت اور سلف صالحین کی غیرت و روایات کا تحفظ اور اس کا فروغ انفرادی و اجتماعی طور پر کرنا۔",
    },
    {
      imageSrc: CustomizeIconImage,
      title: "معاشرتی اصلاح اور دینی خدمت",
      description:
        "3. سماج میں دینی، ملی، دعوتی، اصلاحی، فلاحی اور رفاہی کردار ادا کرتے ہوئے معاشرے کی روحانی اور اخلاقی اصلاح کرنا۔",
    },
    {
      imageSrc: ReliableIconImage,
      title: "عصر حاضر کے لیے علماء و قائدین کی تیاری",
      description:
        "4. ایسے علماء و قائدین کی تیاری جو قرآن و سنت اور منہج سلف صالحین کی روشنی میں موجودہ دور کے چیلنجز کا سامنا کر سکیں۔",
    },
    {
      imageSrc: FastIconImage,
      title: "دین و دنیا کی ہم آہنگ تربیت",
      description:
        "5. طلبہ کے اندر دین اور دنیا کی ہم آہنگ صلاحیتیں پیدا کرنا، تاکہ وہ دونوں جہانوں میں کامیاب ہوں۔",
    },
    {
      imageSrc: SimpleIconImage,
      title: "طلبہ کی متوازن شخصیت سازی",
      description:
        "6. طلبہ کی شخصیت سازی میں اعتقادی، روحانی، علمی، عقلی، جسمانی، نفسیاتی اور اجتماعی پہلوؤں میں توازن پیدا کرنا۔",
    },
    {
      imageSrc: ReliableIconImage,
      title: "طلبہ کی تقریر و تحریر اور تجوید کی تربیت",
      description:
        "7. طلبہ کو تقریر، تحریر، حفظِ قرآن اور تجوید کی مہارتوں میں تربیت دینا اور ان کی صلاحیتوں کو نکھارنا۔",
    },
    {
      imageSrc: ShieldIconImage,
      title: "علاقائی مبلغین کی تیاری",
      description:
        "8. علاقائی زبانوں میں ماہر مبلغین اور دعاۃ تیار کرنا تاکہ دین اسلام کے پیغام کو ہر طبقے تک پہنچایا جا سکے۔",
    },
    {
      imageSrc: ReliableIconImage,
      title: "اتحاد امت اور اختلافات کا خاتمہ",
      description:
        "9. امت مسلمہ کے اتحاد و اتفاق کو فروغ دینا اور امت کے درمیان موجود علمی و فکری اختلافات کو کتاب و سنت کی روشنی میں ختم کرنا۔",
    },
  ];

  const SectionHeading = tw.h2`text-4xl sm:text-5xl font-black tracking-wide text-center [font-family: "Noto Nastaliq Urdu", serif]`;

  return (
    <Container>
      <ThreeColumnContainer>
        <Heading className="special">اغراض و مقاصد</Heading>
        {cards.map((card, i) => (
          <Column key={i}>
            <Card>
              <span className="imageContainer">
                <img src={card.imageSrc || defaultCardImage} alt="" />
              </span>
              <span className="textContainer">
                <span className="title">{card.title}</span>
                <p className="description">{card.description}</p>
              </span>
            </Card>
          </Column>
        ))}
      </ThreeColumnContainer>
      <DecoratorBlob />
    </Container>
  );
};
